import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { USER_DATA } from '../../config/app.config'
import { toastr } from 'react-redux-toastr'

const DepositWithdrawSec = () => {
  const history = useHistory()
  let user = localStorage.getItem(USER_DATA)
  let userData = JSON.parse(user)

  const handleRedirect = (path) => {
    if (userData?.is_demo) {
      toastr.error('', 'Please login from your read ID.')
      return
    }
    history.push(path)
  }
  return (
    <section className="withdraw-deposit-btns mt-1">
      <div className="w-d-main">
        <div className="wd-main-buttons">
          <Link
            onClick={() => handleRedirect('/deposit')}
            className="btn-primary deposit-btn"
          >
            <img
              loading="lazy"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAgpJREFUWIXVl7trFFEUh78TRLJgpYKdwaioCBoSFHwUPhKxsNNOsBAVK0GwFHzifxAsJKW1BtKEoIWPLmFFjFiEFIIoCr7AEF3Zz2InspnsTFwyY/QHw3DvOfecb+4c7pmBZVbkGdVuYAewFvgAVCPidelU6jF13NZ6oh5qsSb3YdpJfkJ9qr7PAFCtq7fVzmTNavVGIQBNIKH2qnfUWgbIhNqjjqjvCtuFFjC96mTOjsxpZykACURFHVoE4FJpAE0gp9SZDIDR0gESiIEMgBm10k6sFanAa4BbQHeGfw04DezNsFeA/WoPcCRlewFcjohvmQDATeBcDvBFYB1wEphuYf8JbAI+Av0pWz/wFbiSB7AlJ/ksMAp8B47m+AEczpjflp5IA+SpE3jZhv8fqaPogP8dQDuvoB09BkaAz6n5BYVbNEAdOAMMA2eBvpS9T42IGCsLYBB4AFSB9Rk+G4DfAEXXwBBwPUn+HLgGvEn5rGweFLkDdeAVsCcZH4+IKfUZcC9rUZE70AGsAr4k463JfXPeoqJrYDdwF9gFDKvTwMa/CXAVOAB0ARdo9IW05tXEvE8o9SFwcIkQY8B5Go2nq4V9MiJm5wZlHEQDwBSNvvE2ZXsUERPNE2WdhAFsT65mfUo7Lnsv+OcAaiXn+7EYwP0Sk9sq/oI/GXUfC4uniOTViBgvOO7S9QtzCm+iMkegcwAAAABJRU5ErkJggg=="
              alt="walletW"
            />
            Deposit
          </Link>
          <Link
            onClick={() => handleRedirect('/withdrawal')}
            to="#"
            className="btn-primary withdraw-btn"
          >
            <img
              loading="lazy"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAkhJREFUWIXNl71rFEEYxn+jFhEEY4xWEjUoaQTxA4JYqH+CprESCYofYKWdFiJY2IhKtLISC0EMQhQUq6TRIhFNlJhGDKKCEo1YaMTcz2L34HJ3u9m9u0UfWJiZfeZ9nnln52PhHyM00kntBA6kUL6FEO42Zim7iVsm43ah4rGBFerXBAP9RYsH9axaSjDQVaR4h/owJf1TeeItyym+CngM7EyhPckTM494UEcSRv1UnYjLaaujKQOH6giX1Etqu7pO/RRnKTMWTIHaDQwAPVW8XcCJqrbvwGFgGhgDrgB7gdXqaBW3BDwHToUQPqeN8l6dUU6rnep8RdukukntV3/GbXNqr3oy5QO9kZoOdbROpxF1W0V9XF2rXq/DnY2fJDxKnYIEzAFtcfkH0AdcBI7U4a7MEG8BlmTgrAfexuXLwJYE8YaQJQPdwB9gArgGDLdKPKuBpcBB4CjQRZSBxfAAGAI+EE1hGTONGAA4Ewv3LcKbJzI7AhwjWpbVS/1OCGEwr4ENRPvD8kV4V4GXwCtgTQJnIzBY903CMsyDrepQXH6jXlDfV3FeJNpv0kBJbVNn4npvHHN/moEsyzArAtAOfInr5RNze1qnVhoA6AVuxuUBdRY4l9Yh130gA84Du4EO4DT1d8bpysqCW7HRKbajSRPDwHHgHdGpWj3I1yGEX+VKqzMAsAeYBKaAj0R7QxmjIYSxSnIRBsroofZeMV9NavVHmBv/nYHfBevVxK82cL9gAzVnQM3PqboP2FyA+HgI4VkBcZvDX6qhq6YAWqM2AAAAAElFTkSuQmCC"
              alt="walletW"
            />
            Withdraw
          </Link>
        </div>
      </div>
    </section>
  )
}

export default DepositWithdrawSec
